module.exports = __webpack_public_path__ + "static/media/lock.28dc255f.svg";